// extracted by mini-css-extract-plugin
export default {"main":"ModalEditarAsistencia_main__20+GZ","intro":"ModalEditarAsistencia_intro__ns8Kp","alert":"ModalEditarAsistencia_alert__25HT9","input":"ModalEditarAsistencia_input__qRq05"};